import CompareController from '@/utils/Controllers/Listing/CompareController';

// import components
import Compare from '@/kenwood/components/organisms/Compare';

export default () => {
  CompareController(Compare);
};
